import { getProductPrice } from "@helpers/products/getProductPrice";

import type { Item } from "@typings/product/item";
import type { ProductConfiguration } from "@typings/product/product";

export default (
  item: Item,
  upsell?: { orderId: number },
  isFbw?: boolean
): ProductConfiguration => {
  const isPromotion = !!(upsell || isFbw);
  const offer =
    item.price <= 0
      ? item.offers.find((o) => o.name === "One Time Sale")
      : item.offers.find((o) => o.name === "Monthly Subscription") || item.offers[0];

  const options =
    isPromotion && promotionOptions[item.id]
      ? promotionOptions[item.id]
      : Object.fromEntries(item.options.map((o) => [o.id, o.values[0].id]));

  return {
    ...getProductPrice(item, offer, options, isPromotion),
    offer,
    isFbw,
    upsell,
    options,
    quantity: 1,
  };
};

const promotionOptions: { [itemId: number]: Record<number, number> } = {
  // Nighttime Edibles
  1: {
    // 20 ct
    1: 3,
    // Extra Strength
    12: 47,
  },
  // Uplift Edibles
  4: {
    // 20 ct
    4: 15,
  },
  // Candy Runtz
  7: {
    // 3.5g
    7: 27,
  },
  // Permanent marker
  8: {
    // 3.5g
    9: 32,
  },
};
